import type { ReactNode, Ref } from "react";
import { Field } from "@design-system/Field/Field";
import type { FieldRootProps } from "@design-system/Field/Field.types";
import styles from "./ChoiceFields.module.scss";

interface ChoiceFieldShellProps {
    invalid: boolean;
    error: ReactNode;
    description?: ReactNode;
    className?: string;
    render?: FieldRootProps["render"];
    children: ReactNode;
    ref?: Ref<HTMLDivElement>;
}

/**
 * `Field` without its label row, for controls that carry their own label or
 * legend. Base UI controls inside pick up `aria-invalid` and the error's
 * `aria-describedby` from `Field.Root`, and the line below is `Field.Message`.
 */
export const ChoiceFieldShell = ({
    invalid,
    error,
    description,
    className,
    render,
    children,
    ref,
}: ChoiceFieldShellProps) => (
    <Field.Root
        ref={ref}
        invalid={invalid}
        className={className}
        render={render}
    >
        {children}
        <Field.Message error={error} description={description} />
    </Field.Root>
);

/** A control's inline label with the same `(optional)` suffix as `Field`. */
export const ChoiceFieldLabel = ({
    label,
    optional,
}: {
    label: ReactNode;
    optional?: boolean;
}) => (
    <>
        {label}
        {optional && (
            <>
                {" "}
                <span className={styles.optional}>(optional)</span>
            </>
        )}
    </>
);
